import Vue from 'vue'
import Router from 'vue-router'
import Widget from '@/components/Widget'
import Start from '@/components/Start'
import ObjectMap from '@/components/ObjectMap'
import Overview from '@/components/Overview'
import ObjectDetail from '@/components/ObjectDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:template/:slug',
      component: Widget,
      children: [
        {
          path: '',
          component: Start
        },
        {
          path: 'overview',
          component: Overview
        },
        {
          path: 'map/:id',
          component: ObjectMap,
          children: [
            {
              path: 'object/:objectId',
              component: ObjectDetail
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js